// extracted by mini-css-extract-plugin
export default {"well":"styles_well__L8BNg"};